import { parseafechainicioServicio } from "../functions/formatoFechas";

function addOneMonth(fecha) {
  if (typeof fecha !== "string") {
    throw new Error("La entrada debe ser una cadena.");
  }

  const [day, month, year] = fecha.split("-").map(Number);

  let newMonth = month + 1;
  let newYear = year;

  if (newMonth > 12) {
    newMonth = 1;
    newYear += 1;
  }

  const newDay = String(day).padStart(2, "0");
  const newMonthString = String(newMonth).padStart(2, "0");
  const newYearString = String(newYear);

  return `${newDay}-${newMonthString}-${newYearString}`;
}
export const generaTablaAmortizacion = (
  total,
  enganche,
  meses,
  fecha,
  interes
) => {
  let saldoCredito = parseFloat(total) - parseFloat(enganche);
  // Mensualidad base redondeada al entero (piso)
  let mensualidadBase = Math.floor(saldoCredito / meses);
  // Residuo que se suma a la última mensualidad
  let residuo = parseFloat((saldoCredito - (mensualidadBase * meses)).toFixed(2));

  let tblAmortizacion = [];
  let fechaPagoSig = parseafechainicioServicio(new Date(fecha));
  let now = parseafechainicioServicio(new Date(fecha));

  // Fila 0: enganche
  let amortizacion = {
    id: 0,
    pago: 0,
    estatus: "P",
    interes: 0,
    fechapago: "",
    moratorio: 0,
    anticipado: 0,
    fechaapagar: now,
    montoapagar: parseFloat(enganche)
  };
  tblAmortizacion.push(amortizacion);

  for (let i = 0; i < meses; i++) {
    fechaPagoSig = addOneMonth(fechaPagoSig);
    // Última mensualidad absorbe el residuo
    let monto = i === meses - 1 ? mensualidadBase + residuo : mensualidadBase;
    let amortizacion = {
      id: i + 1,
      pago: 0,
      estatus: "P",
      interes: 0,
      fechapago: "",
      moratorio: 0,
      anticipado: 0,
      fechaapagar: fechaPagoSig,
      montoapagar: monto
    };
    tblAmortizacion.push(amortizacion);
  }

  return tblAmortizacion;
};
